import { TApplicationState } from '../../types/redux';

export function getFlatViewOrderDetails(state: TApplicationState): string {
  const { newbuilding } = state;

  return newbuilding?.flatViewOrder?.orderStatus?.description || 'Вы записались на просмотр квартиры в данном ЖК!';
}
